import {route} from '@/router/route-utils'

const prefix = '/admin/matches';

const routes = [

    route(
        prefix, 'admin.matches.list', {
            components : {
                main: () => import('./views/AdminMatchesListView')
            },
            requiresAuth: true,
            layout: 'LayoutFull',
            title: 'Partite',
            breadcrumb: [
                {text: 'Partite', active: true},
            ],
        }
    ),
    route(
        prefix + '/new', 'admin.matches.new', {
            components : {
                main: () => import('./views/AdminMatchDetailView')
            },
            requiresAuth: true,
            layout: 'LayoutFull',
            title: 'Partita',
            breadcrumb: [
                {text: 'Partite', to: {name: 'admin.matches.list'}},
                {text: 'Nuova partita', active: true},
            ],
        }
    ),

    route(
        prefix + '/:id', 'admin.matches.show', {
            components : {
                main: () => import('./views/AdminMatchDetailView')
            },
            requiresAuth: true,
            layout: 'LayoutFull',
            title: 'Partita',
            breadcrumb: [
                {text: 'Partite', to: {name: 'admin.matches.list'}},
                {text: 'partita', active: true},
            ],
        }
    ),

];

export default routes
